import api from './api'
import { RequestType } from '../types'

export interface RequestTypeBlock {
  id: string
  requestType: RequestType
  blockDate: string
  blockTime: string | null
  reason: string | null
  allowedDays: number | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface BlockedTypesMap {
  [key: string]: {
    blocked: boolean
    allowedDays?: number
    reason?: string
  }
}

export interface RequestTypeBlockInput {
  requestType: RequestType
  blockDate: string
  blockTime?: string
  reason?: string
  allowedDays?: number
  isActive?: boolean
  delete?: boolean
}

export const requestTypeBlockService = {
  // Obtener todos los bloqueos configurados (admin)
  async getAll(): Promise<RequestTypeBlock[]> {
    const response = await api.get('/configuration/request-type-blocks')
    return response.data.data
  },

  // Obtener tipos actualmente bloqueados (público - para el formulario de nueva solicitud)
  async getActiveBlocks(): Promise<BlockedTypesMap> {
    const response = await api.get('/requests/blocked-types')
    return response.data.data
  },

  // Crear o actualizar un bloqueo
  async upsert(data: RequestTypeBlockInput): Promise<RequestTypeBlock> {
    const response = await api.post('/configuration/request-type-blocks', data)
    return response.data.data
  },

  // Actualizar múltiples bloqueos a la vez
  async bulkUpdate(blocks: RequestTypeBlockInput[]): Promise<void> {
    await api.put('/configuration/request-type-blocks/bulk', { blocks })
  },

  // Eliminar un bloqueo
  async delete(requestType: RequestType): Promise<void> {
    await api.delete(`/configuration/request-type-blocks/${requestType}`)
  },
}
